"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const react_1 = __importStar(require("react"));
const react_transition_group_1 = require("react-transition-group");
const classnames_1 = __importDefault(require("classnames"));
const IcChevronDownSm_1 = __importDefault(require("../Icons/IcChevronDownSm"));
const IcChevronUpSm_1 = __importDefault(require("../Icons/IcChevronUpSm"));
const Accordion = (_a) => {
    var { ariaLabelCollapsed, ariaLabelExpanded, className, children, contentPosition = 'bottom', id, isExpanded = false, label, onChange, prefix, variant = 'inline' } = _a, restProps = __rest(_a, ["ariaLabelCollapsed", "ariaLabelExpanded", "className", "children", "contentPosition", "id", "isExpanded", "label", "onChange", "prefix", "variant"]);
    const containerRef = react_1.useRef(null);
    const contentRef = react_1.useRef(null);
    const accordionBaseClassName = 'bds-c-accordion';
    const accordionClassName = classnames_1.default(accordionBaseClassName, className, {
        [`${accordionBaseClassName}--has-border`]: variant === 'border-box' && !Boolean(prefix),
        [`${accordionBaseClassName}--has-bottom-border`]: variant === 'bottom-border' && !Boolean(prefix),
        [`${accordionBaseClassName}--has-prefix`]: Boolean(prefix),
        [`${accordionBaseClassName}--is-expanded`]: isExpanded
    });
    const calculateContentHeight = () => {
        const container = containerRef.current;
        const content = contentRef.current;
        const contentHeight = content.clientHeight;
        container.style.setProperty('--accordion-height', `${contentHeight}px`);
    };
    react_1.useEffect(() => {
        calculateContentHeight();
    }, [contentPosition]);
    const accordionContent = (react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: `${accordionBaseClassName}__container-`, nodeRef: containerRef, in: isExpanded, timeout: 300 },
        react_1.default.createElement("div", { role: 'region', className: `${accordionBaseClassName}__container`, id: `${id}-container`, "aria-labelledby": `${id}-header-button`, ref: containerRef },
            react_1.default.createElement("div", { className: `${accordionBaseClassName}__content`, ref: contentRef }, children))));
    return (react_1.default.createElement("div", Object.assign({ className: accordionClassName, id: id }, restProps),
        contentPosition === 'top' ? react_1.default.createElement(react_1.default.Fragment, null, accordionContent) : null,
        react_1.default.createElement("div", { className: `${accordionBaseClassName}__header` },
            prefix ? prefix : null,
            react_1.default.createElement("button", { className: `${accordionBaseClassName}__header-button`, id: `${id}-header-button`, "aria-label": isExpanded
                    ? ariaLabelExpanded !== null && ariaLabelExpanded !== void 0 ? ariaLabelExpanded : `Close ${label} accordion`
                    : ariaLabelCollapsed !== null && ariaLabelCollapsed !== void 0 ? ariaLabelCollapsed : `Open ${label} accordion`, "aria-expanded": isExpanded, "aria-controls": `${id}-container`, onClick: onChange },
                react_1.default.createElement("span", { className: `${accordionBaseClassName}__label` }, label),
                react_1.default.createElement("div", { className: `${accordionBaseClassName}__chevron` }, contentPosition === 'bottom' ? (react_1.default.createElement(IcChevronDownSm_1.default, null)) : (react_1.default.createElement(IcChevronUpSm_1.default, null))))),
        contentPosition === 'bottom' ? react_1.default.createElement(react_1.default.Fragment, null, accordionContent) : null));
};
exports.Accordion = Accordion;
exports.default = exports.Accordion;
